import { render, staticRenderFns } from "./FormPayment.vue?vue&type=template&id=88f9b692&"
import script from "./FormPayment.vue?vue&type=script&lang=ts&"
export * from "./FormPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88f9b692')) {
      api.createRecord('88f9b692', component.options)
    } else {
      api.reload('88f9b692', component.options)
    }
    module.hot.accept("./FormPayment.vue?vue&type=template&id=88f9b692&", function () {
      api.rerender('88f9b692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ArPrepayment/FormPayment.vue"
export default component.exports